module.exports = __webpack_public_path__ + "static/media/guide_video.9b204862.mp4";